// RenameLayoutModal.tsx
import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogActions, DialogContent, TextField, Button } from "@mui/material";

export interface DuplicateLayoutModal {
  open: boolean;
  onClose: () => void;
  onSave: (newName: string) => void;
  currentName?: string;
  PaperProps?: React.ComponentProps<typeof Dialog>["PaperProps"];
}

export const DuplicateLayoutModal: React.FC<DuplicateLayoutModal> = ({
  open, onClose, onSave, currentName = "", PaperProps
}) => {
  const [newName, setNewName] = useState(currentName);

  useEffect(() => { setNewName(currentName) }, [currentName]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={PaperProps}>
      <DialogTitle>Duplicar layout</DialogTitle>
      <DialogContent>
        <TextField
          label="Nome do novo layout"
          fullWidth
          margin="normal"
          value={newName}
          onChange={e => setNewName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={() => {
            onSave(newName.trim());
            onClose();
          }}
          disabled={!newName.trim()}
          variant="contained"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
